import { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import { styled } from "@mui/system";
import RefreshIcon from "@mui/icons-material/Refresh";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import useStore from "../store/store";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Offset = styled("div")(({ theme }) => theme.mixins.toolbar);
const ACTIVE_OPACITY = 0.8;
const INACTIVE_OPACITY = 0.3;

const Header = ({ signOut }) => {
  const navigate = useNavigate();
  const [refreshSeats, office, setOffice] = useStore((state) => [
    state.refreshSeats,
    state.office,
    state.setOffice,
  ]);
  // const [opacity, setOpacity] = useState({ ny: ACTIVE_OPACITY, tx: 0.3 });
  const [opacity, setOpacity] = useState({ ny: ACTIVE_OPACITY, tx: ACTIVE_OPACITY });
  const [cursor, setCursor] = useState({ ny: "auto", tx: "pointer" });
  const [disabled, setDisabled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // if (office === "NY") {
    if (location.pathname === "/NY") {
      // setOpacity({ ny: ACTIVE_OPACITY, tx: INACTIVE_OPACITY });
      setCursor({ ny: "auto", tx: "pointer" });
      setDisabled(false);
      setOffice("NY");
      // } else if (office === "TX") {
    } else if (location.pathname === "/TX") {
      // setOpacity({ ny: INACTIVE_OPACITY, tx: ACTIVE_OPACITY });
      setCursor({ ny: "pointer", tx: "auto" });
      setDisabled(false);
      setOffice("TX");
    } else {
      // setOpacity({ ny: INACTIVE_OPACITY, tx: INACTIVE_OPACITY });
      setCursor({ ny: "pointer", tx: "pointer" });
      setDisabled(true);
      setOffice("");
    }

    console.log(location.pathname);
  }, [office]);

  const changeOffice = (newOffice) => {
    console.log(office, newOffice);
    if (office !== newOffice) {
      setOffice(newOffice);
      navigate(`/${newOffice}`, { replace: true });
    }
  };

  const report = () => {
    setOffice("");
    navigate(`/report`, { replace: true });
  };

  const schedule = () => {
    setOffice("");
    navigate(`/schedule`, { replace: true });
  };

  const refresh = async () => {
    console.log(office);
    if (office === "") {
    } else refreshSeats();
  };

  return (
    <>
      <AppBar position="fixed">
        <Toolbar>
          <Container
            maxWidth="100%"
            sx={{
              display: `flex`,
              justifyContent: `space-between`,
              alignItems: "center",
            }}
          >
            <h3 style={{ color: `white`, opacity: 0.7 }} onClick={signOut}>
              SCSK USA Office
            </h3>
          </Container>
          {/* <>navigate("../success", { replace: true });</> */}
          <Typography
            variant="subtitle2"
            component="div"
            sx={{
              marginRight: "10px",
              width: "75px",
              flexGrow: 1,
              opacity: 0.7,
              cursor: "pointer",
            }}
            onClick={signOut}
          >
            Log Off
          </Typography>
          <IconButton
            edge="start"
            onClick={report}
            sx={{
              color: `common.white`,
              marginRight: "15px",
              opacity: ACTIVE_OPACITY,
            }}
          >
            <FactCheckIcon fontSize="small" />
            {/* <SummarizeIcon fontSize="medium" /> */}
          </IconButton>
          <IconButton
            edge="start"
            onClick={schedule}
            sx={{
              color: `common.white`,
              marginRight: "15px",
              opacity: ACTIVE_OPACITY,
            }}
          >
            <CalendarMonthIcon fontSize="small" />
            {/* <SummarizeIcon fontSize="medium" /> */}
          </IconButton>
          <Typography
            variant="subtitle2"
            component="div"
            sx={{
              marginRight: "10px",
              flexGrow: 1,
              opacity: opacity.ny,
              cursor: cursor.ny,
            }}
            onClick={() => changeOffice("NY")}
          >
            NY
          </Typography>
          <Typography
            variant="subtitle2"
            component="div"
            sx={{
              marginRight: "20px",
              flexGrow: 1,
              opacity: opacity.tx,
              cursor: cursor.tx,
            }}
            onClick={() => changeOffice("TX")}
          >
            TX
          </Typography>
          <IconButton
            edge="start"
            aria-label="menu"
            onClick={refresh}
            sx={{
              color: `common.white`,
              opacity: ACTIVE_OPACITY,
              // display: { md: `flex`, lg: `none` },
            }}
            disabled={disabled}
          >
            <RefreshIcon fontSize="small" />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Offset />
    </>
  );
};

export default Header;
